import type { HttpInterceptorFn } from '@angular/common/http';
import { autenticacaoInterceptor } from '@modules/auth/interceptors/autenticacao.interceptor';
import { liberacaoInativaInterceptor } from '@modules/fiscalizacao/interceptors/liberacao-inativa.interceptor';

/**
 * Interceptors HTTP da aplicação, na ordem do `withInterceptors` (o primeiro fica por fora).
 *
 * O de autenticação fica por fora. O de liberação inativa vê a resposta antes e lê o corpo Blob dos
 * downloads, para o de autenticação enxergar o código e não mandar o fiscal para /acesso-negado.
 */
export const INTERCEPTORS_HTTP: HttpInterceptorFn[] = [autenticacaoInterceptor, liberacaoInativaInterceptor];
